import React, { type FC } from 'react';

export const ProfileIcon: FC = () => (
  <svg width="121px" height="121px" viewBox="0 0 121 121" version="1.1">
    <title>Profile icon</title>
    <defs>
      <polygon
        id="path-1"
        points="0 0.8577 120.1422 0.8577 120.1422 120.9997 0 120.9997"
      />
    </defs>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Zero_states_inbox" transform="translate(-797.000000, -376.000000)">
        <g id="Group-10" transform="translate(797.000000, 375.000000)">
          <g id="Group-3" transform="translate(0.000000, 0.143000)">
            <g id="Clip-2" />
            <path
              d="M120.1422,60.9287 C120.1422,94.1047 93.2472,120.9997 60.0712,120.9997 C26.8952,120.9997 -0.0008,94.1047 -0.0008,60.9287 C-0.0008,27.7527 26.8952,0.8577 60.0712,0.8577 C93.2472,0.8577 120.1422,27.7527 120.1422,60.9287"
              id="Fill-1"
              fill="#EAF0FA"
              mask="url(#mask-2)"
            />
          </g>
          <path
            d="M83.0836,40.2451 C83.0836,53.4971 71.3146,68.2551 59.0886,68.2551 C46.9676,68.2551 35.0926,53.4971 35.0926,40.2451 C35.0926,26.9931 45.8356,16.2491 59.0886,16.2491 C72.3406,16.2491 83.0836,26.9931 83.0836,40.2451 Z"
            id="Stroke-4"
            stroke="#031D44"
            strokeWidth="2"
            strokeLinecap="round"
          />
          <path
            d="M13.2144,120.08 L13.2144,108.427 C13.2144,93.333 21.7154,80.347 33.4364,77.671 C41.6034,75.807 51.0804,74.206 59.5474,74.206 C67.5894,74.206 77.2184,75.881 85.6094,77.799 C95.2794,80.011 102.7734,89.198 105.1134,100.818"
            id="Stroke-6"
            stroke="#031D44"
            strokeWidth="2"
            strokeLinecap="round"
          />
          <path
            d="M84.1793,99.998 L69.9173,99.998 C68.2303,99.998 66.8623,98.63 66.8623,96.942 C66.8623,95.254 68.2303,93.886 69.9173,93.886 L84.1793,93.886 C85.8663,93.886 87.2353,95.254 87.2353,96.942 C87.2353,98.63 85.8663,99.998 84.1793,99.998 Z"
            id="Stroke-8"
            stroke="#FFFFFF"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </g>
      </g>
    </g>
  </svg>
);
